import React from 'react';
import './WifiRequiredPopup.css';

export default function WifiRequiredPopup({
  isOpen,
  onClose,
  onRetry,
  actionLabel = 'Order',
  clientIp = ''
}) {
  if (!isOpen) return null;

  const handleRetry = async () => {
    try {
      await onRetry?.();
    } finally {
      // Close regardless; if it still fails with 403, caller can re-open.
      onClose?.();
    }
  };

  return (
    <div className="wifi-popup-overlay" role="dialog" aria-modal="true" onClick={onClose}>
      <div className="wifi-popup" onClick={(e) => e.stopPropagation()}>
        <button className="wifi-popup-close" type="button" onClick={onClose} aria-label="Close">
          ×
        </button>

        <div className="wifi-popup-media" aria-hidden="true">
          <div className="wifi-popup-video-ring">
            <video
              className="wifi-popup-video"
              src={`${process.env.PUBLIC_URL || ''}/animate.webm`}
              autoPlay
              loop
              muted
              playsInline
            />
          </div>
        </div>

        <div className="wifi-popup-content">
          <h3 className="wifi-popup-title">Wi‑Fi required</h3>
          <p className="wifi-popup-message">Please connect to the restaurant Wi‑Fi to {actionLabel}.</p>

          <div className="wifi-popup-actions">
            {typeof onRetry === 'function' ? (
              <button className="wifi-popup-btn primary" type="button" onClick={handleRetry}>
                Try again
              </button>
            ) : null}
            <button className="wifi-popup-btn secondary" type="button" onClick={onClose}>
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
